import React, { memo } from 'react';

/**
 * Search results counter and navigation
 */
const SearchResults = memo(({ 
  searchQuery,
  isSearching, 
  searchResults, 
  currentResultIndex, 
  goToPrevResult, 
  goToNextResult 
}) => {
  if (!searchQuery) return null;

  return (
    <div className="text-xs text-neutral-600 dark:text-neutral-400 flex justify-between items-center">
      <span>
        {isSearching ? (
          <span className="flex items-center">
            <div className="w-3 h-3 mr-1.5 rounded-full border-2 border-brand-primary border-t-transparent animate-spin"></div>
            Searching...
          </span>
        ) : (
          searchResults.length > 0 
            ? `${currentResultIndex + 1} of ${searchResults.length} results` 
            : 'No results found'
        )}
      </span>
      {searchResults.length > 0 && (
        <div className="flex gap-1">
          <button 
            onClick={goToPrevResult}
            className="p-1.5 hover:bg-slate-200 dark:hover:bg-neutral-800 rounded-lg transition-colors"
            title="Previous result (↑)"
            disabled={searchResults.length === 0}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="18 15 12 9 6 15"></polyline>
            </svg>
          </button>
          <button 
            onClick={goToNextResult}
            className="p-1.5 hover:bg-slate-200 dark:hover:bg-neutral-800 rounded-lg transition-colors"
            title="Next result (↓)"
            disabled={searchResults.length === 0}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
});

SearchResults.displayName = 'SearchResults';

export default SearchResults;